import { Component, Input, OnInit, Injector, ElementRef } from '@angular/core';
import {
  Router,
  NavigationStart,
  ActivatedRoute,
  NavigationEnd,
  Route,
  RouterOutlet,
} from '@angular/router';
import { SharedService } from '../services/api/message.service';
import { Subscription, fromEvent, Observable } from 'rxjs';
import { SchoolData } from 'src/app/models/schoolUser';
import { MixpanelService } from 'src/app/mixpanel.service';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SwichBackToPythonComponent } from '../layout/swich-back-to-python/swich-back-to-python.component';
import { NgClass } from '@angular/common';
import { StatusPopupComponent } from '../pages/common/status-popup.component';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { PermissionService } from '../services/auth/permissions.service';
import { CommonModule } from '@angular/common';
import { co } from '@fullcalendar/core/internal-common';

interface toggleSidenav {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss'],

  standalone: true,
  imports: [
    NgClass,
    RouterOutlet,
    NgxUiLoaderModule,
    StatusPopupComponent,
    CommonModule,
    SwichBackToPythonComponent
  ],
})
export class BodyComponent implements OnInit {
  sub!: Subscription;
  title: any;
  hideNavOnJobs: boolean = false;
  public schoolProps!: SchoolData;
  viewAsProducer: any;
  windowLocation: any;
  checkToken: any;
  routeDetect: Boolean = false;
  jobOnly: Boolean = false;
  userRoleSwitch: any;
  isAuthenticated: boolean = false;
  constructor(
    private injector: Injector,
    public activatedRoute: ActivatedRoute,
    private _router: Router,
    private sharedService: SharedService,
    private el: ElementRef,
    private mixpanelService: MixpanelService,
    private ngxService: NgxUiLoaderService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public permissionService: PermissionService
  ) { }
  showBanner = true;
  ngOnInit(): void {
    // Set showBanner based on NavigationEnd for accurate URL
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        console.log('NavigationEnd11 URL:', url); // Debug log for URL

        if (url == '/jobs') {
          this.showBanner = false;
        }
        const href = window.location.href;
        if (href.includes('/public-profile/')) {
          this.showBanner = false;
        }
      }
      if (event instanceof NavigationStart) {
        this.routerChangeMethod(event.url);
      }
    });


    // ...existing code...
    const getCookie = (name: string) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    };
    const accessToken = getCookie('access_token');
    const refreshToken = getCookie('refresh_token');
    this.isAuthenticated = !!(accessToken && refreshToken);

    let userRole = localStorage.getItem('userRole');
    this.userRoleSwitch = userRole;
    const href = window.location.href;
    if (href.includes('/public-profile/')) {
      this.showBanner = false;
    }
    const hostname = window.location.hostname;
    const isQldBeta = hostname === 'qld-beta.classcover.com.au';
    const isLoginOrRegister =
      href.includes('/login') ||
      href.includes('/register') ||
      href.includes('/forgot-password') ||
      href.includes('/reset-password');
    if (
      this.schoolProps?.properties?.job_only_school ||
      userRole == 'GroupCoordinator' ||
      userRole == 'Group' ||
      userRole == 'Teacher' ||
      userRole == 'Tracer' ||
      isQldBeta ||
      isLoginOrRegister
    ) {
      this.jobOnly = true;
    } else {
      this.jobOnly = false;
    }
  }

  @Input() collapsed = true;
  @Input() screenWidth = 0;

  getBodyClass(): string {
    let currentUrl = this._router.url.split('?');
    this.checkToken =
      document.cookie
        .match('(^|;)\\s*' + 'access_token' + '\\s*=\\s*([^;]+)')
        ?.pop() || '';
    this.activatedRoute.params.subscribe((params) => {
      this.viewAsProducer = params['slugId'];
    });
    const href = window.location.href;
    const hostname = window.location.hostname;
    const isQldBeta = hostname === 'qld-beta.classcover.com.au';
    const isLoginOrRegister =
      href.includes('/login') ||
      href.includes('/register') ||
      href.includes('/forgot-password') ||
      href.includes('/reset-password');

    let userRole = localStorage.getItem('userRole');
    if (
      this.schoolProps?.properties?.job_only_school ||
      userRole == 'GroupCoordinator' ||
      userRole == 'Group' ||
      userRole == 'Teacher' ||
      userRole == 'Tracer' ||
      isQldBeta ||
      isLoginOrRegister
    ) {
      this.jobOnly = true;
    } else {
      this.jobOnly = false;
    }
    this.windowLocation = window.location.href.split('/');
    const url = this._router.url;
    let styleClass = '';
    if (
      url === '/' ||
      url === '/login' ||
      url.match(/\/login.*/) ||
      url.match(/\/signup.*/) ||
      url.match(/\/public-profile.*/) ||
      url === '/signup' ||
      url === '/public-profile' ||
      url === '/school-onboarding' ||
      url === '/school-onboarding-findNew' ||
      url === '/onboarding-profile' ||
      url === '/onboarding-completed' ||
      url === '/terms-and-conditions'
    ) {
      styleClass = '';
    }
    if (currentUrl[0] == '/school/terms-and-conditions') {
      styleClass = 'body-consumer';
    } else {
      if (url.match('/school')) {
        styleClass = 'body';
      }
      if (url.match('/group')) {
        styleClass = 'body';
      }
      if (url.match('/co-ordinator')) {
        styleClass = 'body';
      }
      if (url.match('/teacher')) {
        styleClass = 'body-consumer';
      }
      if (url.match('/tracer')) {
        styleClass = 'body';
      }

      if (currentUrl[0] == '/school/jobs/job-details') {
        styleClass = 'body-jobs';
      } else if (currentUrl[0] == '/school/jobs/post-job') {
        styleClass = 'body-jobs';
      } else if (currentUrl[0] == '/school/termsAndCondition') {
        styleClass = 'body-jobs';
      } else if (currentUrl[0] == '/school/school-onboarding') {
        styleClass = 'body-jobs';
      } else if (currentUrl[0] == '/school/school-onboarding-findNew') {
        styleClass = 'body-jobs';
      } else if (currentUrl[0] == '/school/onboarding-profile') {
        styleClass = 'body-jobs';
      } else if (currentUrl[0] == '/school/onboarding-completed') {
        styleClass = 'body-jobs';
      } else {
        if (this.collapsed && this.screenWidth > 996) {
          styleClass = 'body-trimmed';
        } else if (this.screenWidth <= 996 && this.screenWidth > 0) {
          styleClass = 'body-md-screen';
        }
      }
    }
    return styleClass;
  }

  routerChangeMethod(url: any) {
    const href = window.location.href;
    if (href.includes('/public-profile/')) {
      this.showBanner = false;
    }
    const hostname = window.location.hostname;
    const isLoginOrRegister =
      href.includes('/login') ||
      href.includes('/register') ||
      href.includes('/forgot-password') ||
      href.includes('/reset-password');
    const isQldBeta = hostname === 'qld-beta.classcover.com.au';
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    let userRole = localStorage.getItem('userRole');
    this.userRoleSwitch = userRole;
    if (
      this.schoolProps?.properties?.job_only_school ||
      userRole == 'GroupCoordinator' ||
      userRole == 'Group' ||
      userRole == 'Teacher' ||
      userRole == 'Tracer' ||
      isQldBeta ||
      isLoginOrRegister
    ) {
      this.jobOnly = true;
    } else {
      this.jobOnly = false;
    }

    let styleClass = '';
    if (
      url === '/' ||
      url === '/login' ||
      url.match(/\/login.*/) ||
      url.match(/\/signup.*/) ||
      url.match(/\/public-profile.*/) ||
      url === '/signup' ||
      url === '/public-profile' ||
      url === '/school-onboarding' ||
      url === '/school-onboarding-findNew' ||
      url === '/onboarding-profile' ||
      url === '/onboarding-completed' ||
      url === '/terms-and-conditions'
    ) {
      styleClass = '';
    }
    this.title = url.split('?');
    this.title[0]
    if (this.title[0] == '/school/terms-and-conditions') {
      styleClass = 'body-consumer';
    } else {
      if (url.match('/school')) {
        styleClass = 'body';
      }
      if (url.match('/group')) {
        styleClass = 'body';
      }
      if (url.match('/co-ordinator')) {
        styleClass = 'body';
      }
      if (url.match('/teacher')) {
        styleClass = 'body-consumer';
      }
      if (url.match('/tracer')) {
        styleClass = 'body';
      }
      if (this.title[0] == '/school/jobs/job-details') {
        styleClass = 'body-jobs';
      } else if (this.title[0] == '/school/jobs/post-job') {
        styleClass = 'body-jobs';
      } else if (this.title[0] == '/school/termsAndCondition') {
        styleClass = 'body-jobs';
      } else if (this.title[0] == '/school/school-onboarding') {
        styleClass = 'body-jobs';
      } else if (this.title[0] == '/school/school-onboarding-findNew') {
        styleClass = 'body-jobs';
      } else if (this.title[0] == '/school/onboarding-profile') {
        styleClass = 'body-jobs';
      } else if (this.title[0] == '/school/onboarding-completed') {
        styleClass = 'body-jobs';
      } else {
        if (this.collapsed && this.screenWidth > 996) {
          styleClass = 'body-trimmed';
        } else if (this.screenWidth <= 996 && this.screenWidth > 0) {
          styleClass = 'body-md-screen';
        }
      }
    }
    return styleClass;
  }

  ngAfterContentInit() {
    // Set showBanner based on NavigationEnd for accurate URL
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        console.log('NavigationEnd URL:', url); // Debug log for URL

        if (url == '/jobs') {
          this.showBanner = false;
        }
        if (url === '/public-profile/') {
          this.showBanner = false;
        }
      }
      if (event instanceof NavigationStart) {
        this.routerChangeMethod(event.url);
      }
    });


    this.sub = this.sharedService.navData.subscribe((data) => {
      this.hideNavOnJobs = data;
    });
    let userRole = localStorage.getItem('userRole');
    this.userRoleSwitch = userRole;
  }

  switchBack() {
    this.ngxService.start();
    this.commonService.switchBackToPythonTeacher().subscribe({
      next: (res: any) => {
        this.ngxService.stop();
        if (res) {
          window.location.replace(environment.apiUrl);
        } else {
          console.log('error in the response', res);
        }
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(err.message);
        this.ngxService.stop();
      },
    });
  }
}